import React from 'react';
import Form from 'react-bootstrap/Form';
import HTMLRichTextEditor from '@/components/rich_text_editor/HTMLRichTextEditor';
import i18n from 'i18n';

interface ActionReplyEmailFormFieldsProps {
    formik: any;
}

const ActionReplyEmailFormFields: React.FC<ActionReplyEmailFormFieldsProps> = React.memo((
    {
        formik,
    },
) => {

    return (
        <Form.Group className="mb-3" controlId="params.replyMessage" >
            <Form.Label>{i18n.t('jt_reply_message.text')}</Form.Label>
            <HTMLRichTextEditor
                HTMLValue={formik.values.params.replyMessage || ''}
                onChange={(HTMLDump: string) => formik.setFieldValue('params.replyMessage', HTMLDump)}
            />
        </Form.Group >
    );
});


export default ActionReplyEmailFormFields; 